import PropTypes from 'prop-types';
import React from 'react';
import { Modal, Button, ButtonToolbar } from 'react-bootstrap';
import BookingForm from './BookingForm';
import HotelFeedbackLink from './HotelFeedbackLink';
import { EVENT_NAMES } from './EventStyles';
import moment from 'moment';
import HotelsListTable from './HotelsListTable';
import Loading from '../../../components/Loading';
import Layout from '../../../components/Layout';

//Functions for extracting event from tour

let hotels = [];
class AddBookingModal extends React.Component {
  constructor(props) {
    super(props);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onGroupChange = this.onGroupChange.bind(this);
    this.onEventChange = this.onEventChange.bind(this);
    this.placeTextBoxChange = this.placeTextBoxChange.bind(this);
    this.handlePlaceSelect = this.handlePlaceSelect.bind(this);
    this.changeCheckBox = this.changeCheckBox.bind(this);
    this.checkboxFormatter = this.checkboxFormatter.bind(this);
    this.checkboxkingFormatter = this.checkboxkingFormatter.bind(this);
    this.checkboxdoubleFormatter = this.checkboxdoubleFormatter.bind(this);
    this.onBeforeSaveCell = this.onBeforeSaveCell.bind(this);
    this.onAfterSaveCell = this.onAfterSaveCell.bind(this);
    this.onRateChange = this.onRateChange.bind(this);
    this.closeDefineRateModal = this.closeDefineRateModal.bind(this);
    this.calculateTotalValue = this.calculateTotalValue.bind(this);
    this.calculateAndUpdateTotalValue = this.calculateAndUpdateTotalValue.bind(this);
    this.showDefineRateModal = this.showDefineRateModal.bind(this);
    this.handleLocationChange = this.handleLocationChange.bind(this);
    this.handleLocationChangeAdvanceSearch = this.handleLocationChangeAdvanceSearch.bind(this);
    this.closeHotelsListModal = this.closeHotelsListModal.bind(this);
    this.handleAdvanceSearch = this.handleAdvanceSearch.bind(this);
    const bidData = [];
    const cellEditProp = {
      mode: 'dbclick',
      blurToSave: true,
      beforeSaveCell: this.onBeforeSaveCell,
      afterSaveCell: this.onAfterSaveCell,
    };
    const bid_details_input = {
      tax_rate: '',
      taxes_fees: '',
      commission_rate: Number(15).toFixed(2),
      bidData: bidData,
      currency: 'USD',
      additional_tax: 0,
      resort_fee: 0,
      total: 0
    };

    let sum = 0;
    bid_details_input.bidData.map(c => {
      const a = moment(c.check_out_date);
      const b = moment(c.check_in_date);
      sum += Number(c.no_of_Guest) * a.diff(b, 'days') * Number(c.rate_per_night)
    })

    sum += Number(bid_details_input.tax_rate / 100.0 || 0) * sum;
    bid_details_input.total = sum + Number(bid_details_input.taxes_fees);
    this.state = {
      place: '',
      formatted_address: '',
      google_place_id: '',
      address: '',
      selectedEventId: 0,
      cellEditProp,
      bid_details_input: bid_details_input,
      currency_initial_value: {
        label: '🇺🇸 USD - US Dollar',
        value: 'USD',
      },
      showDefineRateModalFlag: false,
      showSetRoomTypes: false,
      selectedGroup: '',
      roomTypeData: {
        'Suite': 0,
        'King': 0,
        'Double': 0,
        'Two Beds':0,
        'Junior Suite':0,
        '2 Bedroom Suite':0
      },
      searchText: '',
      showHotelsList: false,
      isLoading: false,
      advanceSearchText: '',
      changeCheckBoxValue: false,
      updatedRowVlaue: []
    };
  }
  handlebidData = (values) => {
    let payloaddummy = [];
    let counter = 0
    let roomCounter = 0;

    for (let i = 0; i < this.state.bid_details_input.bidData.length; i++) {
      const formData = this.state.bid_details_input.bidData[i];
      if (formData.roomType === 'Choose Room Types') {
        continue
      }
      const totalRoomsForFormData = formData.numberOfRooms;
      const bid_ids = formData.id;
      const roomType = formData.roomType === 'Suite' ? 'Suite' : formData.roomType === 'King' ? 'King' : formData.roomType === 'Double' ? 'Double' : formData.roomType==='Two Beds'?'Two Beds':formData.roomType==='Junior Suite'?'Junior Suite':formData.roomType==='2 Bedroom Suite'?'2 Bedroom Suite':'';
      for (let j = 0; j < totalRoomsForFormData; j++) {
        let idToPush = 0; // Initialize with 0
        if (bid_ids && bid_ids.length > j) {
          idToPush = bid_ids[j];
        } else {
          idToPush = 0;
        }
        const ratePerNigth = this.state.bid_details_input.bidData.filter(itm => (itm.roomType === formData.roomType && itm.date_in === formData.date_in && itm.date_out === formData.date_out))
        payloaddummy.push({
          suite: formData.roomType === 'Suite',
          king: formData.roomType === 'King',
          double: formData.roomType === 'Double',
          twobeds: formData.roomType === 'Two Beds',
          Juniorsuite: formData.roomType === 'Junior Suite',
          twobedroomsuite: formData.roomType === '2 Bedroom Suite',
          check_in_date: formData.date_in,
          check_out_date: formData.date_out,
          travelprofile_id: 0,
          tour_id: this.props.tour.id,
          event_id: (values.event && values.event.value) ? values.event.value : '',
          group_id: (values.group && values.group.value) ? values.group.value : '',
          room_type: formData.roomType === 'Suite' ? 1 : formData.roomType === 'King' ? 2 : formData.roomType === 'Double' ? 3 : formData.roomType === 'Two Beds' ? 4 : formData.roomType === 'Junior Suite' ? 5 : formData.roomType === '2 Bedroom Suite' ? 6 : 0,// Adjust the logic for room types as per your requirements
          id: idToPush,
          rate_per_night: ratePerNigth[0].rate_per_night
        });
        // console.table(payloaddummy)

        roomCounter++;
        counter++;
      }
    }
    return payloaddummy
  }

  handleSubmit(values) {
    const biddatapaylod = this.handlebidData(values)
    const payloadBid = {
      address: values.address ? values.address : '',
      note: values.note ? values.note : '',
      event_id: (values.event && values.event.value) ? values.event.value : '',
      group_id: (values.group && values.group.value) ? values.group.value : '',
      //currency: (values.currency && values.currency.value) ? values.currency.value : 'USD',
      currency: (this.state.currency_initial_value && this.state.currency_initial_value.value) ? this.state.currency_initial_value.value : 'USD',
      google_place_id: this.state.google_place_id ? this.state.google_place_id : '',
      formatted_address: this.state.formatted_address ? this.state.formatted_address : '',
      place: this.state.place ? this.state.place : '',
      tax_rate: this.state.bid_details_input.tax_rate ? Number(this.state.bid_details_input.tax_rate / 100.0).toFixed(3) : '',
      additional_tax: this.state.bid_details_input.additional_tax ? Number(this.state.bid_details_input.additional_tax) : 0,
      resort_fee: this.state.bid_details_input.resort_fee ? Number(this.state.bid_details_input.resort_fee) : 0,
      taxes_fees: this.state.bid_details_input.taxes_fees ? this.state.bid_details_input.taxes_fees : '',
      commission_rate: this.state.bid_details_input.commission_rate ? Number(this.state.bid_details_input.commission_rate / 100.0).toFixed(3) : '',
      total: this.state.bid_details_input.total ? this.state.bid_details_input.total : '',
      tour: this.props.tour.id ? this.props.tour.id : 0,
      bid_details_input: biddatapaylod ? biddatapaylod : [],
      user: this.props.user ? this.props.user : []
    };

    payloadBid.commission_rate = payloadBid.commission_rate == '' ? 0 : payloadBid.commission_rate;

    if (typeof (values.selected_hotel) == 'undefined') {
      alert("Please select a Hotel.");
      return false;
    } else if (typeof (values.event) == 'undefined') {
      alert("Please select a Event.");
      return false;
    } else if (typeof (values.group) == 'undefined') {
      alert("Please select a Group.");
      return false;
    } else if (this.state.currency_initial_value == null) {
      alert("Please select a Currency.");
      return false;
    } else if (this.state.google_place_id == '') {
      alert("Please select a Hotel by searching using search button");
      return false;
    }

    document.querySelector(`#btnAddBookingSubmit`).disabled = true;

    this.props.saveAddBookingData(payloadBid, (response) => {
      console.log(response);
      this.props.onClose();
      window.location.reload();
    });
  }
  handleCancel(event) {
    event.preventDefault();
    this.props.onClose();
  }
  handleChange(value) {
    this.setState(
      { currency_initial_value: value }
    );
  }
  placeTextBoxChange(values) {
  }
  handleLocationChange = (event) => {
    this.setState({
      searchText: event.target.value
    })
  }
  handleLocationChangeAdvanceSearch = (event) => {
    this.setState({
      advanceSearchText: event.target.value
    })
  }
  handleShowSetRoomTypes = () => {
    this.setState({
      showSetRoomTypes: true
    })
  }
  handleCloseSetRoomTypes = () => {
    this.setState({
      showSetRoomTypes: false
    })
  }
  onRateChange = (e, type) => {
    let value = e.target.value;
    let name = type == "tax_rate" ? "Tax Rate" : (type == "rate_per_night" ? "Rate Per Night" : (type == "commission_rate" ? "Commision" : (type == "additional_tax" ? "Additional Tax" : "Resort Fee")))
    if (value.startsWith("00")) {
      alert(`please enter valid value into ${name} Field`)
    }
    this.calculateTotalValue(type, e.target.value);
  }
  onBeforeSaveCell = (row, cellName, cellValue) => {
    if (cellName == 'rate_per_night') {
      let value = Math.sign(cellValue);
      if (value == -1) {
        alert('Please enter valid "Rate per night" value.')
      }
    }
    if (cellName == 'check_in_date' || cellName == 'check_out_date') {
      let checkInDate, checkOutDate;
      if (cellName == 'check_in_date') {
        checkInDate = new Date(cellValue);
        checkOutDate = new Date(row.check_out_date);
      } else if (cellName == 'check_out_date') {
        checkInDate = new Date(row.check_in_date);
        checkOutDate = new Date(cellValue);
      }

      if (checkInDate > checkOutDate) {
        this.setState({ showWarning: true, modalText: "Check-in date should be before the check-out date" });
        return false;
      }
    }
  }

  onAfterSaveCell = (row, cellName, cellValue) => {
    if (cellName == 'check_in_date' || cellName == 'check_out_date') {
      const isSeleted = row.Suite || row.King || row.Double;
      let type = 0
      if (isSeleted) {

        if (row.Suite)
          type = 1;
        if (row.King)
          type = 2;
        if (row.Double)
          type = 3;

        const payloadBid = {
          suite: row.Suite,
          king: row.King,
          double: row.Double,
          check_in_date: row.check_in_date,
          check_out_date: row.check_out_date,
          travelprofile_id: row.id,
          tour_id: this.props.tour.id,
          group_id: row.group_id,
          bid_id: 0,
          event_id: this.state.selectedEventId,
          id: row.bid_detail_id,
          room_type: type
        };
        /*this.props.addBidDetail(payloadBid, (response) => {
          console.log(response);
        });*/
      }
    }

    if (cellName == 'first_name' || cellName == 'last_name') {
      const payload = { first_name: row.first_name, last_name: row.last_name };
      this.props.editMember(row.id, payload);
    }

    if (cellName == 'rate_per_night') {
      this.calculateTotalValue(cellName, cellValue);
    }
  }

  calculateTotalValue = (type, targetValue) => {
    var bid_details_input = { ...this.state.bid_details_input }
    bid_details_input[type] = targetValue;

    this.calculateAndUpdateTotalValue(bid_details_input);
  }

  calculateAndUpdateTotalValue(bid_details_input) {
    let sum = 0;
    let additionalTax = Number(bid_details_input.additional_tax);
    let resortFee = Number(bid_details_input.resort_fee);
    const bidData = this.handlebidData(bid_details_input.bidData)
    bidData.map(c => {
      let val = Math.sign(c.rate_per_night);
      if (val == -1) {
        c.rate_per_night = 0
      };
      const a = moment(c.check_out_date);
      const b = moment(c.check_in_date);
      sum += 1 * a.diff(b, 'days') * Number(c.rate_per_night)
    })

    sum += Number(bid_details_input.tax_rate / 100.0 || 0) * sum;
    console.log('bid data for rate--->', bidData)
    bidData.map(bid => {
      if (bid.rate_per_night) {
        const check_out = moment(bid.check_out_date);
        const check_in = moment(bid.check_in_date);
        if (resortFee == 0) {
          sum += 1 * check_out.diff(check_in, 'days') * additionalTax
        }
        if (additionalTax == 0) {
          sum += 1 * check_out.diff(check_in, 'days') * resortFee
        }
        if (additionalTax != 0 && resortFee != 0) {
          sum += 1 * check_out.diff(check_in, 'days') * additionalTax
          sum += 1 * check_out.diff(check_in, 'days') * resortFee
        }

      }
    })
    // sum += Number(bid_details_input.additional_tax)
    bid_details_input.total = parseFloat(sum + Number(bid_details_input.taxes_fees)).toFixed(2);

    this.setState({
      bid_details_input
    })
  }

  // //Checkbox Formatter
  changeCheckBox = (e, row, type) => {
    // document.querySelector(`#suite_${row.id}`).disabled = true;
    // document.querySelector(`#king_${row.id}`).disabled = true;
    // document.querySelector(`#double_${row.id}`).disabled = true;
    const memberData = [...this.state.bid_details_input.bidData];
    const data = memberData.find(o => o.id == row.id);
    let output = e.target.checked;

    let selectedRoom = '';
    let unselectedRoom = [];

    switch (type) {
      case 1:
        selectedRoom = "Suite"
        unselectedRoom.push("King")
        unselectedRoom.push("Double")
        break;
      case 2:
        selectedRoom = "King"
        unselectedRoom.push("Suite")
        unselectedRoom.push("Double")
        break;
      case 3:
        selectedRoom = "Double"
        unselectedRoom.push("King")
        unselectedRoom.push("Suite")
        break;
    }

    data[selectedRoom] = output ? 1 : 0;
    data[unselectedRoom[0]] = 0;
    data[unselectedRoom[1]] = 0;
    data["isDisable"] = true

    const payloadBid = {
      suite: data.Suite,
      king: data.King,
      double: data.Double,
      check_in_date: data.check_in_date,
      check_out_date: data.check_out_date,
      travelprofile_id: data.id,
      tour_id: this.props.tour.id,
      group_id: data.group_id,
      bid_id: 0,
      event_id: this.state.selectedEventId,
      id: data.bid_detail_id,
      room_type: type
    };
    this.setState({
      changeCheckBoxValue: true
    })

    /*this.props.addBidDetail(payloadBid, (response) => {
      data.bid_detail_id = response.id;
      document.querySelector(`#suite_${row.id}`).disabled = false;
      document.querySelector(`#king_${row.id}`).disabled = false;
      document.querySelector(`#double_${row.id}`).disabled = false;
    })*/

  }
  changeStateValue = () => {
    this.setState({
      changeCheckBoxValue: false
    })
  }

  handlechangevalue = () => {
    this.calculateAndUpdateTotalValue(this.state.bid_details_input)
    this.setState({
      changeCheckBoxValue: false,
    });
  }

  
  checkboxFormatter = (cell, row) => {
    const id = `suite_${row.id}`
    return (
      <input type='checkbox' id={id} checked={row.Suite} onChange={(e) => this.changeCheckBox(e, row, 1)} />
    )
  }
  checkboxkingFormatter = (cell, row) => {
    const id = `king_${row.id}`
    return (
      <input type='checkbox' id={id} checked={row.King} onChange={(e) => this.changeCheckBox(e, row, 2)} />
    )
  }

  checkboxdoubleFormatter = (cell, row) => {
    const id = `double_${row.id}`
    return (
      <input type='checkbox' id={id} checked={row.Double} onChange={(e) => this.changeCheckBox(e, row, 3)} />
    )
  }

  checkboxsuiteFormatterRoomType = (cell, row, enumObject) => {
    let nameAttr = row.group_id + '_roomTypeoptions';
    return (
      <input type='radio' name={nameAttr} id={row.group_id} onChange={(e) => this.updateRoomType(e, row, 1)} />
    )
  }


  checkboxkingFormatterRoomType = (cell, row, enumObject) => {
    let nameAttr = row.group_id + '_roomTypeoptions';
    return (
      <input type='radio' name={nameAttr} id={row.group_id} onChange={(e) => this.updateRoomType(e, row, 2)} />
    )
  }

  checkboxdoubleFormatterRoomType = (cell, row, enumObject) => {
    let nameAttr = row.group_id + '_roomTypeoptions';
    return (
      <input type='radio' name={nameAttr} id={row.group_id} onChange={(e) => this.updateRoomType(e, row, 3)} />
    )
  }

  updateRoomType = (e, row, type) => {
    let roomTypeData = {};
    let selectedRoom = '';
    let unselectedRoom = [];

    switch (type) {
      case 1:
        selectedRoom = "Suite"
        unselectedRoom.push("King")
        unselectedRoom.push("Double")
        break;
      case 2:
        selectedRoom = "King"
        unselectedRoom.push("Suite")
        unselectedRoom.push("Double")
        break;
      case 3:
        selectedRoom = "Double"
        unselectedRoom.push("King")
        unselectedRoom.push("Suite")
        break;
    }

    row[selectedRoom] = 1;
    row[unselectedRoom[0]] = 0;
    row[unselectedRoom[1]] = 0;

    roomTypeData['Suite'] = row.Suite;
    roomTypeData['King'] = row.King
    roomTypeData['Double'] = row.Double
    roomTypeData['room_type'] = type

    this.setState({
      roomTypeData: roomTypeData
    })

  }

  handleUpdateRoomTypes = () => {
    let roomTypes = this.state.roomTypeData;
    let bidDetailData = this.state.bid_details_input;
    bidDetailData.bidData.forEach((bid) => {
      bid.Suite = roomTypes.Suite;
      bid.King = roomTypes.King;
      bid.Double = roomTypes.Double;
    })
    roomTypes.Suite = 0;
    roomTypes.King = 0;
    roomTypes.Double = 0;

    this.setState({
      bid_details_input: bidDetailData,
      roomTypeData: roomTypes,
      changeCheckBoxValue: true,
    })

    this.handleCloseSetRoomTypes();

  }

  //Function called when event selection changed
  onEventChange(values) {
    this.setState({
      selectedEventId: values.value,
    })
  }

  showDefineRateModal() {
    this.setState({ showDefineRateModalFlag: true });
  }

  closeDefineRateModal() {
    this.setState({ showDefineRateModalFlag: false });
  }

  showBidData = (bid_details) => {
    const uniqueRooms = new Map();

    for (const bid of bid_details) {
      const roomType = bid.suite ? 'Suite' : bid.king ? 'King' : bid.double ? 'Double' : bid.twobeds ? 'Two Beds' : bid.Juniorsuite ? 'Junior Suite' : '2 Bedroom Suite';
      const key = `${roomType}-${bid.check_in_date}-${bid.check_out_date}`;

      if (!uniqueRooms.has(key)) {
        uniqueRooms.set(key, {
          id: [bid.id],
          roomType,
          numberOfRooms: 1,
          date_in: bid.check_in_date || this.props.currentEventDate,
          date_out: bid.check_out_date,
          numberOfNights: this.calculateNumberOfNights(bid.check_in_date, bid.check_out_date),
          rate_per_night: this.state.roomTypeData[roomType]
        });
      } else {
        const room = uniqueRooms.get(key);
        room.id.push(bid.id);
        room.numberOfRooms++;
      }
    }

    const newBiddata = Array.from(uniqueRooms.values());
    // this.setState({ newBiddata, isLoading: false });
    return newBiddata
  };

  calculateNumberOfNights = (checkInDate, checkOutDate) => {
    const diffInTime = new Date(checkOutDate).getTime() - new Date(checkInDate).getTime();
    return (diffInTime / (1000 * 3600 * 24)).toString();
  };

  //Function called when group selection changed
  onGroupChange(values) {
    const memberData = [];
    let selectedGroup = [];
    const group_id = values.value;
    //const thisPropsEvent = this.props.tour.tour_stops[0].related_group_events;
    const selectedEvent = this.props.tour.tour_stops.filter(itm => (itm.id === this.state.selectedEventId))
    const thisPropsEventOld = selectedEvent[0].related_group_events.filter(itm => (itm.group == group_id) ? itm : '')
    const thisPropsEvent = thisPropsEventOld[0];

    const member_data = this.props.tour.members.filter(itm => itm.group.id == group_id ? itm : '');
    const bid_details = thisPropsEvent.bids.bid_details.filter(itm => (itm.group_id == group_id) ? itm : '')
    const newBiddata = this.showBidData(bid_details)

    const group_bid_data = this.props.tour.group_bid_data.filter(itm => itm.group_id == group_id ? itm : '');

    let temp_data = [];
    let temp_group_bid_data = [];

    for (let i = 0; i < member_data.length; i++) {
      if (member_data[i].group.id == group_id) {
        temp_data = bid_details.filter(itm => itm.travelprofile_id == member_data[i].id ? itm : '')
        temp_group_bid_data = group_bid_data.filter(itm => itm.travelprofile_id == member_data[i].id ? itm : '')

        memberData.push({
          id: member_data[i].id,
          first_name: member_data[i].first_name !== '' ? member_data[i].first_name : 'Guest',
          last_name: member_data[i].last_name !== '' ? member_data[i].last_name : 'Guest',
          Suite: (temp_group_bid_data.length && temp_group_bid_data[0].suite !== 'undefined' && temp_group_bid_data[0].suite !== null) ? temp_group_bid_data[0].suite : 0,
          King: (temp_group_bid_data.length && temp_group_bid_data[0].king !== 'undefined' && temp_group_bid_data[0].king !== null) ? temp_group_bid_data[0].king : 0,
          Double: (temp_group_bid_data.length && temp_group_bid_data[0].double !== 'undefined' && temp_group_bid_data[0].double !== null) ? temp_group_bid_data[0].double : 0,
          check_in_date: temp_data.length ? temp_data[0].check_in_date : thisPropsEvent.start,
          check_out_date: temp_data.length ? temp_data[0].check_out_date : thisPropsEvent.end,
          group_id: thisPropsEvent.group,
          user_id: member_data[i].id,
          bid_detail_id: temp_data.length ? temp_data[0].id : 0,
          bid_id: temp_data.length ? temp_data[0].bid_id : 0,
          rate_per_night: 0,
          travelprofile_id: member_data[i].id
        });
        temp_data.pop();
      }
    }

    //this.state.bid_details_input.bidData = memberData;
    let bid_details_input = { ...this.state.bid_details_input }
    bid_details_input.bidData = newBiddata
    selectedGroup.push({
      group: values.label,
      group_id: values.value
    })
    this.setState({
      bid_details_input,
      selectedGroup: selectedGroup,
      changeCheckBoxValue: true,
    })

  }
  handlePlaceSelect = (addressObject) => {
    this.setState({
      place: addressObject.name,
      formatted_address: addressObject.formatted_address,
      google_place_id: addressObject.place_id,
      address: addressObject.formatted_address,
    }, () =>
      console.log('addressObject.formatted_address =' + this.state.address))

  }

  handleLocationSelect = (hotelName, placeId, hotelAddress, additional, resort) => {
    let bid_details_input = { ...this.state.bid_details_input }
    bid_details_input.additional_tax = additional ? additional : 0
    bid_details_input.resort_fee = resort ? resort : 0
    this.setState({
      place: hotelName,
      google_place_id: placeId,
      formatted_address: hotelAddress,
      address: hotelAddress,
      searchText: hotelName,
      bid_details_input
    })
    document.getElementById('selectHotelField').value = hotelName;
    this.closeHotelsListModal();
  }

  handleShowHotelsList = (event) => {
    let isValidSearchText = this.state.searchText ? this.state.searchText.trim() : this.state.searchText
    if (!isValidSearchText) {
      alert("Please Enter a Hotel Name");
      return
    }
    this.setState({
      isLoading: true,
      showHotelsList: true,
      advanceSearchText: this.state.searchText
    })
    let hasSearchPrefs = false;
    this.props.requestHotelSearch(this.state.searchText, hasSearchPrefs, (response) => {
      let hotelsList = response.results
      hotels = [];
      hotels = (<HotelsListTable
        hotels={hotelsList}
        handleLocationSelect={this.handleLocationSelect}
        isAdvanceSearch={false}
      />)
      this.setState({
        isLoading: false
      })
    });
  }

  closeHotelsListModal = () => {
    this.setState({
      showHotelsList: false
    })
  }

  handleAdvanceSearch() {
    this.setState({
      isLoading: true
    })
    this.props.requestHotelAdvanceSearch(this.state.advanceSearchText, (response) => {
      let hotelsList = response.results
      hotels = [];
      hotels = (<HotelsListTable
        hotels={hotelsList}
        handleLocationSelect={this.handleLocationSelect}
        isAdvanceSearch={true}
      />)
      this.setState({
        isLoading: false
      })
    })
  }

  renderForm() {
    const spinner = (
      <div className="text-center">
        <i className="fa fa-spinner fa-pulse fa-5x fa-fw" />
        <span className="sr-only">Loading...</span>
      </div>
    );
    const eventList = [];
    const route = [];
    console.log('renderForm called')
    this.props.tour.tour_stops.forEach((event) => {
      //formatEvent(event, route);

      eventList.push({
        label: event.place.city,
        value: event.id
      })
      // if (event.events) {
      //   for (let i = 0, len = event.events.length; i < len; i += 1) {
      //     //formatEvent(event.events[i], route);
      //     eventList.push({
      //         label: event.events[i].name,
      //         value: event.events[i].id
      //       }
      //     );
      //   }
      // }
    });
    const groups = [];
    this.props.groups.forEach(group => {
      groups.push({
        label: group.name,
        value: group.id,
      });
    });

    return (
      <div>
        <Modal bsSize="large" show={this.props.show} onHide={this.props.onClose}>
          <Modal.Header closeButton>
            <Modal.Title>Add Bid</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <BookingForm
              onSubmit={this.handleSubmit}
              handlePlaceSelect={this.handlePlaceSelect}
              groups={groups}
              tour={this.props.tour}
              onGroupChange={this.onGroupChange}
              onEventChange={this.onEventChange}
              onAddressChange={this.onAddressChange}
              //hotelAddress={this.state.formatted_address}
              address={this.state.address}
              placeTextBoxChange={this.placeTextBoxChange}
              changeCheckBox={this.changeCheckBox}
              checkboxFormatter={this.checkboxFormatter}
              checkboxkingFormatter={this.checkboxkingFormatter}
              checkboxdoubleFormatter={this.checkboxdoubleFormatter}
              eventList={eventList}
              onBeforeSaveCell={this.onBeforeSaveCell}
              onAfterSaveCell={this.onAfterSaveCell}
              cellEditProp={this.state.cellEditProp}
              onRateChange={this.onRateChange}
              currency_initial_value={this.state.currency_initial_value}
              bid_details_input={this.state.bid_details_input}
              handleCancel={this.handleCancel}
              handleChange={this.handleChange}
              showDefineRateModalFlag={this.state.showDefineRateModalFlag}
              showDefineRateModal={this.showDefineRateModal}
              closeDefineRateModal={this.closeDefineRateModal}
              calculateAndUpdateTotalValue={this.calculateAndUpdateTotalValue}
              handleShowSetRoomTypes={this.handleShowSetRoomTypes}
              isGroupSelected={this.state.selectedGroup != '' ? true : false}
              showSetRoomTypes={this.state.showSetRoomTypes}
              handleCloseSetRoomTypes={this.handleCloseSetRoomTypes}
              selectedGroup={this.state.selectedGroup}
              handleUpdateRoomTypes={this.handleUpdateRoomTypes}
              checkboxsuiteFormatterRoomType={this.checkboxsuiteFormatterRoomType}
              checkboxkingFormatterRoomType={this.checkboxkingFormatterRoomType}
              checkboxdoubleFormatterRoomType={this.checkboxdoubleFormatterRoomType}
              handleLocationChange={this.handleLocationChange}
              handleShowHotelsList={this.handleShowHotelsList}
              changeCheckBoxValue={this.state.changeCheckBoxValue}
              changeStateValue={this.changeStateValue}
              handlechangevalue={(row, fieldName, value) => this.handlechangevalue(row, fieldName, value)}
              updatedRowVlaue={this.state.updatedRowVlaue}
            />
          </Modal.Body>
          <Modal.Footer >
            <HotelFeedbackLink id={this.props.id} />
          </Modal.Footer>
        </Modal>

        {this.state.showHotelsList && (<Modal className="hotels-list-modal" show={this.state.showHotelsList} onHide={this.closeHotelsListModal} backdrop="static">
          <Modal.Header closeButton>
            <Modal.Title>Hotels</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row" style={{ padding: '10px' }}>
              <div className="col-sm-12 col-md-6 col-lg-6">
                <input
                  id="advanceSearchField"
                  className='form-control'
                  type="text"
                  placeholder="Enter a Hotel Name"
                  value={this.state.advanceSearchText}
                  onChange={this.handleLocationChangeAdvanceSearch}
                />
              </div>
              <div className="col-sm-12 col-md-4 col-lg-4">
                <ButtonToolbar>
                  <Button
                    bsStyle="success"
                    onClick={this.handleAdvanceSearch}
                    disabled={this.state.advanceSearchText && this.state.advanceSearchText.trim() !== '' ? false : true}
                  >
                    Search From Web
                  </Button>
                </ButtonToolbar>
              </div>
            </div>
            {!this.state.isLoading ? hotels : spinner}
          </Modal.Body>
          <Modal.Footer style={{ clear: 'both' }} />
        </Modal>)}
      </div>
    );
  }
  render() {
    return this.renderForm();
  }
}

AddBookingModal.propTypes = {
  /*bid: PropTypes.object.isRequired,*/
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired, groups: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.String,
    })
  ).isRequired,
};
export default AddBookingModal;


// WEBPACK FOOTER //
// src/routes/tours/components/AddBookingModal.js